import React from "react";
import { slide as Menu } from "react-burger-menu";
import styles from "./BurgerMenu.module.css";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  return (
    // Pass on our props
    <Menu {...props}>
      <Link to="/">
        <div className={styles.topMenuText}>Vote</div>
      </Link>
      <Link to="/propose">
        <div className={styles.topMenuText}>Make a Proposal</div>
      </Link>
      <Link to="/buy-voton">
        <Button className={styles.topButtons}>
          <div className={styles.topButtonText}>Buy Token</div>
        </Button>
      </Link>
    </Menu>
  );
};
